import styled from 'styled-components';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';

const Tooltip = styled.p`
  ${FontStyles.text7};

  position: absolute;
  bottom: 40%;
  left: 16px;
  z-index: 10;
  max-width: 522px;
  padding: 16px;
  margin: 0;
  background-color: ${Colors.white1};
  color: ${Colors.black1};
  border: 1px solid ${Colors.black1};
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgb(177, 177, 177);
  white-space: pre-wrap;
`;

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Purchase/components/Tooltip.js